export default "__VITE_ASSET__Dte$naLK__"